export type DomainErrorFields = Record<string, string>;

/**
 * Erro de regra de negócio. `name` e `code` são propriedades próprias para atravessar o RPC
 * dos Durable Objects (o `instanceof` não atravessa). Quem converte em HTTP usa `isDomainError`.
 */
export class DomainError extends Error {
  readonly code: string;
  declare readonly fields?: DomainErrorFields;

  constructor(code: string, message?: string, fields?: DomainErrorFields) {
    super(message ?? code);
    this.name = "DomainError";
    this.code = code;
    if (fields) Object.defineProperty(this, "fields", { value: fields, enumerable: true });
  }
}

/** Reconhece um DomainError pelo formato, inclusive quando ele chega pelo RPC como `Error` comum. */
export function isDomainError(
  err: unknown,
): err is { name: "DomainError"; code: string; message: string; fields?: DomainErrorFields } {
  if (typeof err !== "object" || err === null) return false;
  const e = err as { name?: unknown; code?: unknown; message?: unknown };
  return e.name === "DomainError" && typeof e.code === "string" && typeof e.message === "string";
}
